import {SortField, useDeleteUser, User, useUsers} from "@/hooks/useUsers";
import UserTable from "@/features/users/components/UserTable";
import UserUpsertDialog from "@/features/users/components/UserUpsertDialog";
import {useMemo} from "react";
import HeaderTextButton from "@/components/HeaderTextButton.tsx";
import {useQueryModal} from "@/hooks/useQueryModal.ts";
import {useTableQuery} from "@/hooks/useTableQuery.ts";

export default function AdminUsersPage() {
    const {
        searchParams,
        editId,
        isNew,
        modalOpen,
        setParam,
        openCreate,
        openEdit,
        closeModal,
    } = useQueryModal();

    const {
        page,
        size,
        sortBy,
        sortOrder,
        setPage,
        onRequestSort,
    } = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 10,
        defaultSortBy: "name",
        defaultSortOrder: "desc",
    });

    const {
        data: result = {page, size, total: 0, items: []} as any,
        isLoading,
        isError
    } = useUsers({page, size, sortBy, sortOrder});

    const {mutateAsync: deleteBanner} = useDeleteUser();

    const initialForDialog: Partial<User> | null = useMemo(() => {
        if (isNew) return null;
        if (editId) return result.items.find((c: User) => c.id === editId) ?? null;
        return null;
    }, [isNew, editId, result]);

    return (
        <>
            <HeaderTextButton
                title="Users"
                description="Manage application users."
                label="Add User"
                onClick={openCreate}
            />

            <UserTable
                content={result}
                isLoading={isLoading}
                isError={isError}
                onCreate={openCreate}
                onEdit={openEdit}
                onDelete={deleteBanner}
                setPage={setPage}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onRequestSort={onRequestSort}
            />

            <UserUpsertDialog
                open={modalOpen}
                initial={initialForDialog}
                onClose={closeModal}/>
        </>
    );
}
